import { PageNotFound } from "@inductiveautomation/ws-components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <PageNotFound
      onClick={() => void navigate("/")}
      heading={t("not_found.heading")}
      supportingText={t("not_found.supporting_text")}
      buttonLabel={t("not_found.button_label")}
      testId="page-not-found"
    />
  );
};

export default NotFound;
